/*
 * Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { useTranslation } from 'react-i18next';

import { Icon } from '@/components/Icon';
import { presetFor } from '@/lib/roles';
import { useRoleView } from '@/stores/roleView';

/** Banner shown while a "view as" role override is active. */
export function RoleViewBanner() {
  const { t } = useTranslation();
  const presetId = useRoleView((s) => s.presetId);
  const clear = useRoleView((s) => s.clear);
  const preset = presetFor(presetId);
  if (!preset) return null;
  return (
    <div className="role-banner" role="status">
      <Icon name="user" size={15} />
      <span className="role-banner-t">
        {t('roles.banner.viewingAs', { role: t(preset.labelKey) })}
      </span>
      <button type="button" className="role-banner-exit" onClick={clear}>
        <Icon name="close" size={14} /> {t('roles.banner.exit')}
      </button>
    </div>
  );
}
